// src/axios.js
import axios from 'axios';
import { getHeaderAccessToken } from './headerTokens';

const PROD_API = 'https://api.ianalytics.nl';
// Eigen domeinen en platforms die het portaal insluiten (IXON) praten rechtstreeks met de API.
// Elk ander domein is een klantdomein (portal.klant.nl): de Cloudflare Worker afterbase-portal stuurt
// /api, /auth enz. door naar de API, dus same-origin. Een nieuw klantdomein vraagt hier geen wijziging
// meer (werkpakket 6b, docs/portaldomeinen.md).
const DIRECT_API_HOSTS = ['portal.ianalytics.nl', 'localhost', '127.0.0.1', 'ixon.cloud'];
const DIRECT_API_SUFFIXES = ['.ianalytics.nl', '.ixon.cloud', '.cloudfront.net'];

export function pickBaseUrl(host = window.location.hostname, origin = window.location.origin,
                            env = process.env.NODE_ENV) {
  if (env === 'development') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
  }
  const h = String(host || '').toLowerCase();
  if (!h || DIRECT_API_HOSTS.includes(h) || DIRECT_API_SUFFIXES.some(s => h.endsWith(s))
      || /^[0-9.]+$/.test(h)) return PROD_API;
  return origin;
}

const BASE_URL = pickBaseUrl();

export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  xsrfCookieName: 'csrf_access_token',
  xsrfHeaderName: 'X-CSRF-TOKEN',
});

export const api_noIntercept = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

function attachAuthAndCsrf(config) {
  const isRefresh = (config.url || '').endsWith('/auth/refresh');
  const access = getHeaderAccessToken();

  // Een expliciet meegegeven Authorization-header (met name het refresh-token)
  // mag nooit door het access-token worden overschreven.
  const explicitAuthorization =
    typeof config.headers?.get === 'function'
      ? config.headers.get('Authorization')
      : config.headers?.Authorization;

  // Stuur bij /auth/refresh niet automatisch het access-token mee.
  // Die route verwacht óf de refresh-cookie óf een expliciet refresh-token.
  if (access && !isRefresh && !explicitAuthorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${access}`;
  }

  const getCookie = (name) =>
    document.cookie.split('; ').reduce((r, v) => {
      const [k, val] = v.split('=');
      return k === name ? decodeURIComponent(val) : r;
    }, '');

  const csrfToken = isRefresh ? getCookie('csrf_refresh_token') : getCookie('csrf_access_token');
  if (csrfToken) {
    config.headers = config.headers || {};
    config.headers['X-CSRF-TOKEN'] = csrfToken;
  }
  return config;
}

api.interceptors.request.use(attachAuthAndCsrf);
api_noIntercept.interceptors.request.use(attachAuthAndCsrf);

export default api;
